// extracted by mini-css-extract-plugin
module.exports = {"date":"DateTime_date__18vr4","time":"DateTime_time__3Bnko","timeDots":"DateTime_timeDots__2JOHE"};